<template>
    <div id="settings-page">
        <loader v-if="is('loading')"></loader>

        <div class="container-fluid" v-if="is('ready')">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <div class="box clearfix">
                        <h1>{{ t('orderStatus-page_title') }}</h1>
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>{{ t('orderStatus-external_label_column') }}</th>
                                    <th>{{ t('orderStatus-kevi_status_column') }}</th>
                                    <th class="text-center">
                                        {{ t('orderStatus-repurchase_reference_column') }}
                                        <span class="tooltip-inline repurchase-reference-info">
                                            <span class="mdi mdi-information-variant"></span>
                                            <span class="tooltip-content">
                                                {{ t('orderStatus-repurchase_reference_help') }}
                                            </span>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="status in externalStatus"
                                    :key="status.id"
                                >
                                    <td>{{ status.external_label }}</td>
                                    <td>
                                        <select
                                            v-model="status.kevi_status"
                                            class="form-control"
                                        >
                                            <option value="approved">
                                                {{ t('orderStatus-approved') }}
                                            </option>
                                            <option value="pending">
                                                {{ t('orderStatus-pending') }}
                                            </option>
                                            <option value="cancelled">
                                                {{ t('orderStatus-cancelled') }}
                                            </option>
                                        </select>
                                    </td>
                                    <td class="text-center repurchase-reference-cell">
                                        <input
                                            type="checkbox"
                                            v-model="status.is_repurchase_reference"
                                            :true-value="1"
                                            :false-value="0"
                                            :title="t('orderStatus-repurchase_reference_column')"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <button
                            class="btn btn-success pull-right"
                            @click.prevent="save"
                            :disabled="is('saving')"
                        >
                            <span
                                class="fa fa-spin fa-spinner"
                                v-if="is('saving')"
                            ></span>
                            {{ t('orderStatus-save') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi";

export default {
    props: {
        user: Object,
    },
    data: function () {
        return {
            state: "ready",
            externalStatus: [],
        };
    },
    computed: {
        place() {
            return this.$store.state.place;
        },
    },
    created: function () {
        document.getElementsByTagName("title")[0].innerText = this.t('orderStatus-title');
        this.loadData();
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        is: function (state) {
            return this.state === state;
        },
        setState: function (state) {
            this.state = state;
        },
        loadData: function () {
            let options = keviApi.getOptions(
                "settings/external-order-status",
                "GET",
            );
            this.setState("loading");
            this.$http(options).then((response) => {
                if (response.status === 200) {
                    this.externalStatus = response.body.status || [];
                }
                this.setState("ready");
            });
        },
        save: function () {
            var options = keviApi.getOptions(
                "settings/external-order-status",
                "POST",
                { ...this.externalStatus },
            );
            window?.mixpanel?.track("Settings - save status");
            this.setState("saving");
            this.$http(options).then((response) => {
                this.$store.dispatch(
                    "notification/success",
                    this.t('orderStatus-success_message'),
                );
                if (response.status === 200) {
                    this.externalStatus = response.body.status || [];
                }
                this.setState("ready");
            });
        },
    },
};
</script>
<style scoped>
#settings-page {
    max-width: 1000px;
}
.repurchase-reference-cell input[type="checkbox"] {
    transform: scale(1.2);
    cursor: pointer;
}
.repurchase-reference-info {
    cursor: help;
    font-size: 0.85em;
}
.repurchase-reference-info .tooltip-content {
    font-size: 13px;
    line-height: 1.4;
    white-space: normal;
    bottom: auto;
    top: 100%;
    margin-top: 10px;
    margin-bottom: 0;
}
.repurchase-reference-info .tooltip-content::after {
    bottom: auto;
    top: -5px;
}
</style>
